import React, { useContext, useRef, useState } from "react";
import SplitImg from "../images/split_img.png";
import ShowIcon from "./ShowIcon";
import { TbEdit } from "react-icons/tb";
import { PiNote } from "react-icons/pi";
import {
  RiFolderAddLine,
  RiFolderTransferLine,
} from "react-icons/ri";
import copy from "copy-to-clipboard";
import { Tooltip } from "react-tooltip";
import { BsCopy } from "react-icons/bs";
import NoImage from "../images/no-image.png";
import { DataContext } from "../context/DataContext";
import { TiDeleteOutline } from "react-icons/ti";
import { LiaUserPlusSolid } from "react-icons/lia";
import ShareuserIcons from "./ShareuserIcons";
import { newDateChanger } from "../Utils/CommonFunction";

function SplitView({
  data,
  sharetoggle,
  edittoggle,
  confirmtoggle,
  noButton,
  onCopypassword,
}) {
  const { passwordAccess } = useContext(DataContext);

  let count = 0;

  const CopyIcon = (cp) => {
    const [copied, setCopied] = useState(false);
    return (
      <div
        onClick={async () => {
          const res = await cp.onCopy();
          copy(res);
          setCopied(true);
        }}
        data-tooltip-id={cp?.id}
        data-tooltip-content={copied ? "Copied!" : "Copy"}
      >
        <BsCopy
          style={{
            width: "15px",
            height: "15px",
            cursor: "pointer",
            margin: 3,
          }}
          color="A2C1D8"
        />
        <Tooltip place="top" effect="float" id={cp?.id} />
      </div>
    );
  };
  return (
    <div className="split-view-inner">
      <img className="split-view-inner-img " src={SplitImg} alt="" />
      <h3>API’s</h3>
      <div className="row apiRow">
        <div className="col-6 text-end">Identifier</div>
        <div className="col-6">{data?.identifier}</div>
        <div className="col-6 text-end">Host/ Domain</div>
        <div className="col-6">{data?.platform || "NA"}</div>
        <div className="col-6 text-end">Port</div>
        <div className="col-6">{data?.port || "NA"}</div>
        <div className="col-6 text-end">Username/API Key</div>
        <div className="col-6 icon-plus-value ">
          <span>
            {data?.username?.slice(0, 4) +
              data?.username
                ?.slice(4, data?.username?.length)
                .replace(/\S/g, "*") ||
              data?.apiKey?.slice(0, 4) +
                data?.apiKey
                  ?.slice(4, data?.apiKey?.length - 4)
                  .replace(/\S/g, "*") ||
              "NA"}
          </span>

          <CopyIcon
            id={data?.identifier}
            onCopy={async () => {
              return data?.username || data?.apiKey || "NA";
            }}
          />
        </div>
        <div className="col-6 text-end">Password /API Secret</div>
        <div className="col-6 icon-plus-value">
          <span>xxxxxxxxxxxx</span>
          <CopyIcon
            id={data?.identifier}
            onCopy={async () => {
              const a = await onCopypassword(
                data?.passwordId ? data?.passwordId : data?._id
              );
              return a;
            }}
          />
        </div>
        <div className="col-6 text-end">Updated On</div>
        <div className="col-6">{newDateChanger(data?.updatedAt)}</div>
        <div className="col-6 text-end">Share with</div>
        <div className="col-6">
          <div className="shareUserPan">
            <ul>
              {passwordAccess?.passwordAccess?.map((item, index) => {
                count = count + 1;
                return count < 6 ? (
                  <li key={index + "fal"}>
                    <img
                      className="userImg memberIcon "
                      src={item?.profilePhoto || NoImage}
                      alt="user"
                      referrerPolicy="no-referrer"
                    />
                  </li>
                ) : null;
              })}
              {passwordAccess?.envAccess?.map((item, index) => {
                count = count + 1;
                return count < 6 ? (
                  <li key={index + "fal"}>
                    <img
                      className="userImg memberIcon "
                      src={item?.profilePhoto || NoImage}
                      alt="user"
                      referrerPolicy="no-referrer"
                    />
                  </li>
                ) : null;
              })}
              {passwordAccess?.folderAccess?.map((item, index) => {
                count = count + 1;
                return count < 6 ? (
                  <li key={index + "fal"}>
                    <img
                      className="userImg memberIcon "
                      src={item?.profilePhoto || NoImage}
                      alt="user"
                      referrerPolicy="no-referrer"
                    />
                  </li>
                ) : null;
              })}
              {count > 5 ? <li className="text">5+</li> : null}
            </ul>
          </div>
        </div>
        <div className="col-6 text-end">Notes</div>
        <div className="col-6 wardWrap ">{data?.note || "NA"}</div>
      </div>

      {/* <div className="split-view-folderName">
        <p>{data?.folderName || "root"}</p>
      </div> */}
      {data?.folderName ? (
        <div className="split-view-folderName">
          <p>
            {data?.folderName} {`>`} {data?.envName}
          </p>
        </div>
      ) : (
        <div className="split-view-folderName">
          <p>root</p>
        </div>
      )}
      {noButton ? null : (
        <div className="split-view-inner-icon">
          <ShowIcon
            iconName={<LiaUserPlusSolid className="iconstyle-svg" />}
            tooltip_id="Share"
            tooltip_content="Share"
            onIconClick={() => sharetoggle(data)}
            className="split-view-inner-icon-bg"
          />{" "}
          {/* <ShowIcon
          iconName={<PiNote className="iconstyle-svg" />}
          tooltip_id="note"
          tooltip_content="Note"
          onIconClick={() => console.log("Note click")}
          className="split-view-inner-icon-bg"
        /> */}
          {/* <ShowIcon
          iconName={
            <RiFolderTransferLine className="iconstyle-svg" />
          }
          tooltip_id="move"
          tooltip_content="Move"
          onIconClick={() => console.log("Move click")}
          className="split-view-inner-icon-bg"
        /> */}
          {/* <ShowIcon
          iconName={<RiFolderAddLine className="iconstyle-svg" />}
          tooltip_id="create_folder "
          tooltip_content=" Create folder"
          onIconClick={() => console.log("Create Folder click")}
          className="split-view-inner-icon-bg"
        /> */}
          <ShowIcon
            iconName={<TbEdit className="iconstyle-svg" />}
            tooltip_id="edit"
            tooltip_content="Edit"
            onIconClick={() => edittoggle(data)}
            className="split-view-inner-icon-bg"
          />
          <ShowIcon
            iconName={<TiDeleteOutline className="iconstyle-svg" />}
            tooltip_id="delete"
            tooltip_content="Delete"
            onIconClick={() => confirmtoggle(data?._id)}
            className="split-view-inner-icon-bg"
          />
        </div>
      )}

      {/* <div className="split-view-button">
        <PiNote className="iconstyle-svg" />
        <h6>Share History</h6>
      </div> */}
    </div>
  );
}

export default SplitView;
